import React from "react";
import { Link } from "react-router-dom";
import TerraformArticle from "../components/TerraformArticle";
import { usePageTitle } from "../hooks/usePageTitle";
import "../assets/styles/TerraformArticle.scss";

function TerraformPage() {
  usePageTitle("Déploiement Azure via Terraform");
  return (
    <div className="terraform-page">
      <Link to="/projects" className="article-back-btn">← Projets</Link>
      <TerraformArticle />
    </div>
  );
}

export default TerraformPage;
